import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type Props = {
  training: {
    trainingId: string
    name: string
  }
}

const MyTrainingsCatalogHeader: FC<Props> = ({ training }) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const requestCourse = () => {
    navigate(
      navigation.myTrainings.catalog.detail.fromCatalog.fullPath({
        trainingId: training.trainingId,
      })
    )
  }
  return (
    <ResourceHeader
      title={training.name}
      primaryAction={{
        label: i18n.t('trainings.training_catalog.header.request_course'),
        onClick: requestCourse,
      }}
    />
  )
}

export default MyTrainingsCatalogHeader
